import { connect } from 'react-redux';
import { compose } from 'recompose';

import { getShowTerminatedUsers } from '../selectors';
import { setShowTerminatedUsersThunk } from '../actions';

import TerminatedUsersCheckbox from '../../admin/userList/components/TerminatedUsersCheckbox';

const mapStateToProps = (state) => {
  return {
    showTerminatedUsers: getShowTerminatedUsers(state),
  };
};

const mapDispatchToProps = {
  setShowTerminatedUsersAction: setShowTerminatedUsersThunk,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(withRedux);

export default enhance(TerminatedUsersCheckbox);
